<template>

    <div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasCart" ref="offcanvasCart" aria-labelledby="offcanvasCartLabel">
        <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="offcanvasCartLabel">
                {{ __('Warenkorb') }}
            </h5>
            <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" :aria-label="__('Close')"></button>
        </div>
        <div class="offcanvas-body">
            <div v-for="item in items">
                <div class="row">
                    <div class="col-4">
                        <inertia-link :href="item.product.permalink">
                            <img class="img-fluid thumbnail" :src="item.product.main_image_url" alt="" loading="lazy">
                        </inertia-link>
                    </div>
                    <div class="col-8">
                        <h5 class="fs-6">
                            <inertia-link :href="item.product.permalink" class="link-dark">
                                {{ item.product.name }}
                            </inertia-link>
                        </h5>
                        <tax-info :product="item.product" />
                        <delivery-info :product="item.product" />
                        <!--                        @todo 
                        <div class="d-flex justify-content-between mt-2">
                                                    <quantity />
                                                    <inertia-link 
                                                        :href="route('cart.remove-item', item)"
                                                        type="button"
                                                        method="delete"
                                                        class="btn btn-danger">
                                                        <i class="bi bi-x-lg"></i>
                                                        {{ __('Entfernen') }}
                                                    </inertia-link>
                                                </div>-->
                        <div class="fw-bold mt-2">
                            123,00 €
                        </div>
                    </div>
                </div>
                <hr />
            </div>
        </div>
        <div class="p-3 d-grid gap-3">
            <div>
                <inertia-link :href="route('cart.index')" class="btn btn-lg btn-outline-secondary w-100" @click="closeOffcanvasCart">
                    {{ __('Zum Warenkorb') }}
                </inertia-link>
            </div>
            <div>
                <inertia-link :href="route('checkout.index')" class="btn btn-lg btn-primary text-white w-100" @click="closeOffcanvasCart">
                    {{ __('Zur Bestellung') }}
                    <i class="bi bi-arrow-right"></i>
                </inertia-link>
            </div>
        </div>
    </div>

</template>

<script>
    import Quantity from '@/shared/Quantity';
        import TaxInfo from '@/shared/TaxInfo';
    import DeliveryInfo from '@/shared/DeliveryInfo';

    export default {
        props: {
        },
        data() {
            return {
                items: this.$page.props.shop.cartItems,
            }
        },
        components: {
            Quantity,
            TaxInfo,
            DeliveryInfo,
        },
        methods: {
            closeOffcanvasCart() {
                // @fixme
                this.$refs.offcanvasCart.hide();
            },
            removeItem() {
                console.log('Remove item');
            },
            increaseCount() {
                console.log('Increase count');
            },
            decreaseCount() {
                console.log('Decrease count');
            }
        },
    }
</script>